import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { RecetaService, CanalesCompartir } from "app/services/receta.service";
import { Receta } from "app/models/receta.interface";

interface CompartirRecetaData {
  recetas: Receta[];
  paciente: { email: string; celular: string };
  canales: CanalesCompartir;
}

@Component({
  selector: "app-compartir-receta-dialog",
  templateUrl: "./compartir-receta-dialog.component.html",
  styleUrls: ["./compartir-receta-dialog.component.scss"],
})
export class CompartirRecetaDialogComponent {
  method: "whatsapp" | "email" = "whatsapp";
  enviando = false;
  error = "";
  enviado = false;
  canales: CanalesCompartir;

  constructor(
    public dialogRef: MatDialogRef<CompartirRecetaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CompartirRecetaData,
    private recetaService: RecetaService,
  ) {
    this.canales = data.canales || {};
    // Seleccionar el primer canal habilitado por defecto
    if (!this.canales.whatsapp && this.canales.email) {
      this.method = "email";
    }
  }

  get destination(): string {
    return this.method === "whatsapp"
      ? this.data.paciente.celular
      : this.data.paciente.email;
  }

  get destinationLabel(): string {
    return this.method === "whatsapp" ? "Número de teléfono" : "Email";
  }

  onMethodChange(): void {
    this.error = "";
  }

  enviar(): void {
    if (this.enviando) return;

    this.enviando = true;
    this.error = "";

    const ids = this.data.recetas.map((r) => r.id);

    this.recetaService
      .sharePrescriptions({
        ids,
        method: this.method,
      })
      .pipe(finalize(() => (this.enviando = false)))
      .subscribe({
        next: () => {
          this.enviado = true;
        },
        error: (err) => {
          this.error = err.error?.error || "Error al enviar las recetas";
        },
      });
  }
}
